<div class="widget">
  <div class="amSuite-widget-header">
    <h5>
      {{'widgets.smart-box.title' | translate}}
      @if (editMode) {
      <a href="javascript:void(0)" (click)="editSmartBox()" class="modify-btn float-right">
        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
      </a>
      }
    </h5>
  </div>

  <div class="amSuite-widget-block height-auto">
    @for (smartButton of selectedSmartButtons; track $index) {
    <a [class]="smartButton.buttonClass" [pTooltip]="smartButton.tooltip" (click)="navigateTo(smartButton)"
      [style.background]="smartButton.backgroundColor ? smartButton.backgroundColor : ''">
      <span [class]="smartButton.buttonIcon" [style]="smartButton.buttonStyle"></span>
      {{smartButton.viewName}}
    </a>
    }
  </div>
</div>

<p-dialog [(visible)]="showEditModal" [modal]="true" [draggable]="false" [style]="{width: '75vw'}" appendTo="body">
  <ng-template pTemplate="header">
    <h5>{{ 'widgets.smart-box.title'| translate }}</h5>
  </ng-template>

  @if (smartButtons) {
  <div>
    <div class="row">
      <div class="col-sm-5 col-md-5 col-lg-5">
        <div class="row buttonsBox">
          <h5 class="headerTitle"> {{'widgets.smart-box.enabled' | translate}}</h5>
          @for (smartButton of smartButtons; track $index) {
          <div class="col-sm-2 col-md-2 col-lg-2" pDraggable="smartButton" (onDragStart)="dragStart(smartButton)"
            (onDragEnd)="dragEnd()">
            <a [class]="smartButton.buttonClass" [pTooltip]="smartButton.tooltip"
              [style.background]="smartButton.backgroundColor ? smartButton.backgroundColor : ''">
              <span [class]="smartButton.buttonIcon" style="padding-right: 0; padding-top: 0; float: none;"></span>
              {{smartButton.viewName}}
            </a>
          </div>
          }
        </div>
      </div>
      <div class="col-sm-1 col-md-1 col-lg-1">
        <p-divider layout="vertical"></p-divider>
      </div>
      <div class="col-sm-5 col-md-5 col-lg-5">
        <div class="row buttonsBox" pDroppable="smartButton" (onDrop)="drop()">
          <h5 class="headerTitle"> {{'widgets.smart-box.used' | translate}}</h5>
          @for (selectedSmartButton of selectedSmartButtons; track $index) {
          <div class="col-sm-2 col-md-2 col-lg-2" pDraggable="selectedSmartButton" pDroppable="selectedSmartButton"
            (onDragStart)="moveSmartButtonStart(selectedSmartButton)" (onDragEnd)="moveSmartButtonEnd()"
            (onDrop)="moveButton($index)">
            <a [class]="selectedSmartButton.buttonClass" [pTooltip]="selectedSmartButton.tooltip"
              (click)="showButtonParams(selectedSmartButton)"
              [style.background]="selectedSmartButton.backgroundColor ? selectedSmartButton.backgroundColor : ''">
              <span [class]="selectedSmartButton.buttonIcon"
                style="padding-right: 0; padding-top: 0; float: none;"></span>
              {{selectedSmartButton.viewName}}
            </a>
          </div>
          }
        </div>
      </div>
      @if (showButtonBin) {
      <div class="col-sm-1 col-md-1 col-lg-1">
        <div class="deleteBox" pDroppable="selectedSmartButton" (onDrop)="removeButton()">
          <i class="pi pi-trash deleteIcon"></i>
        </div>
      </div>
      }
    </div>
    @if (selectedButtonToEdit) {
    <div class="editBox">
      @if (selectedButtonToEdit.custom) {
      <div>
        <div class="row editRow">
          <div class="col-sm-4 col-md-4 col-lg-4">
            <label class="editLabel">{{'widgets.smart-box.name' | translate}}</label>
          </div>
          <div class="col-sm-8 col-md-8 col-lg-8">
            <input type="text" pInputText [(ngModel)]="selectedButtonToEdit.viewName" />
          </div>
        </div>
        <div class="row editRow">
          <div class="col-sm-4 col-md-4 col-lg-4">
            <label class="editLabel">{{'widgets.smart-box.tooltip' | translate}}</label>
          </div>
          <div class="col-sm-8 col-md-8 col-lg-8">
            <input type="text" pInputText [(ngModel)]="selectedButtonToEdit.tooltip" />
          </div>
        </div>
        @if (selectedButtonToEdit.name === 'Custom link' || selectedButtonToEdit.name === '') {
        <div class="row editRow">
          <div class="col-sm-4 col-md-4 col-lg-4">
            <label class="editLabel">{{'widgets.smart-box.url' | translate}}</label>
          </div>
          <div class="col-sm-8 col-md-8 col-lg-8">
            <input type="text" pInputText [(ngModel)]="selectedButtonToEdit.url" />
          </div>
        </div>
        }
        @if (selectedButtonToEdit.name === 'Custom Dialog' || selectedButtonToEdit.name === 'CDialog') {
        <div class="row editRow">
          <div class="col-sm-4 col-md-4 col-lg-4">
            <label class="editLabel">{{'widgets.smart-box.typology' | translate}}</label>
          </div>
          <div class="col-sm-8 col-md-8 col-lg-8">
            @if (dialogRequestTypes) {
            <p-dropdown [options]="dialogRequestTypes" [(ngModel)]="selectedButtonToEdit.params.idRequestTypology"
              optionLabel="description" optionValue="id" appendTo="body">
            </p-dropdown>
            }
          </div>
        </div>
        }
        <div class="row editRow">
          <div class="col-sm-4 col-md-4 col-lg-4">
            <label class="editLabel">{{'widgets.smart-box.appIcon' | translate}}</label>
          </div>
          <div class="col-sm-8 col-md-8 col-lg-8">
            <div class="tableHeader">
              <div class="tableCell">
                <i [class]="selectedIcon.iconClass" style="color: black; margin-top: -7px;"></i>
              </div>
              <div class="tableCell">
                <div style="margin-left: 10px;">
                  <p-button [raised]="true" styleClass="p-button-success p-button-outlined" icon="pi pi-pencil"
                    (click)="iconsOP.toggle($event)"></p-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 col-md-4 col-lg-4">
            <label class="editLabel">{{'widgets.smart-box.colorApp' | translate}}</label>
          </div>
          <div class="col-sm-8 col-md-8 col-lg-8">

            <div class="tableCell">
              <div class="row">
                <p-colorPicker appendTo="body" [(ngModel)]="selectedButtonToEdit.backgroundColor"></p-colorPicker>

              </div>
              <div class="row" style="margin-top: 10px;">
                <input type="text" pInputText [(ngModel)]="selectedButtonToEdit.backgroundColor" />
              </div>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
      }
      @if (!selectedButtonToEdit.custom) {
      <div>
        <label>Non è possibile modificare questo pulsante</label>
      </div>
      }
    </div>
    }
  </div>
  }
  <p-footer>
    <p-button [raised]="true" [label]="'app.confirm' | translate" (click)="confirmEdit()"
      styleClass="p-button-success"></p-button>

    <p-button [raised]="true" [label]="'app.cancel' | translate" (click)="closeModal()"
      styleClass="p-button-danger"></p-button>
  </p-footer>
</p-dialog>

<p-overlayPanel #iconsOP appendTo="body" [dismissable]="true" [showCloseIcon]="true">
  <ng-template pTemplate>
    <div class="row" style="max-width: 32rem; max-height: 25rem; overflow: auto;">
      @for (icon of icons; track $index) {
      <div class="col-sm-2 col-md-2 col-lg-2">
        <a class="tile tile-sm tile-white" (click)="selectIcon(icon); iconsOP.hide()">
          <span [class]="icon.iconClass" style="padding-right: 0; padding-top: 0; float: none;color: black;"></span>
          <span style="color:black; font-size: 12px;margin-left: 0px;"> {{icon.name}}</span>
        </a>
      </div>
      }
    </div>
  </ng-template>
</p-overlayPanel>